import React, { useEffect, useState } from "react";
import { AsideCard, Hint, Lab } from "./EditorChrome";
import { buscarConfirmacao, textoDaConfirmacao, type ConfirmacaoDoWhatsapp } from "../../../../../utils/aviso-whatsapp";

/** Equipe: o que o cliente respondeu no cartão "Ele chama você?" da Home dele. */
export const ConfirmacaoDoWhatsappDoCliente: React.FC<{ profileId: string }> = ({ profileId }) => {
  const [confirmacao, setConfirmacao] = useState<ConfirmacaoDoWhatsapp | null>(null);

  useEffect(() => {
    let ativo = true;
    buscarConfirmacao(profileId).then((ultima) => {
      if (ativo) setConfirmacao(ultima);
    });
    return () => {
      ativo = false;
    };
  }, [profileId]);

  if (!confirmacao) return null;

  return (
    <AsideCard style={{ gap: 6 }}>
      <Lab>WhatsApp conferido pelo cliente</Lab>
      <span style={{ fontSize: 14 }}>{textoDaConfirmacao(confirmacao)}</span>
      {confirmacao.usuario && <Hint>Respondido por {confirmacao.usuario}.</Hint>}
    </AsideCard>
  );
};
